import React, { useRef, useMemo, useCallback } from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Billing } from 'models/BillingModel';
import { BillingColumn } from 'models/BaseModel';
import AsyncSelect from 'react-select/async';
import { Client } from 'models/ClientModel';
import { MessageType } from 'models/BaseModel';
import { useSearchParams } from 'react-router-dom';


const BillingMultiForm: React.FC = () => {
  const width = { hsc: 35, diagnosis: 35, price: 10, quantity: 10, amount:10}
  const [formId, formName] = [Code.Form.Id.BILLING, Code.Form.Name.BILLING];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [columnOptions, setColumnOptions] = Hooks.Form.Options();
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [hscOptions, setHscOptions] = Hooks.Form.OptionMore();
  const [diagOptions, setDiagOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [dataTypeOptions, setDataTypeOptions] = Hooks.Form.Options();
  const [billingColumnData, setBillingColumnData] = useState<BillingColumn[]>([]);
  const [messageTemp, setMessageTemp] = useState<MessageType>(Code.Message.None);
  const [formData, setFormData] = useState<Billing>({});

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const doctorId = searchParams.get(Code.UrlPara.Doctor);
  const examId = searchParams.get(Code.UrlPara.Exam);
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);

  //fetch billing data of the day
  useEffect(() => {
    Files.Json.Http(Code.File.REPORT+Code.File.COLUMN, Code.Option.Common.NOTHING, setColumnOptions, setError);
    Files.Json.Http(Code.File.DATA+Code.File.TYPE, Code.Option.Common.BLANK, setDataTypeOptions, setError);
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.SELECT, setDoctorOptions, setError);
    Files.Json.HttpMore(Code.File.HSC, Code.Option.Common.SELECT, setHscOptions, setError);
    Files.Json.Http(Code.File.DIAG, Code.Option.Common.SELECT, setDiagOptions, setError);
    Files.Json.Http(Code.File.CLAIM+Code.File.STATUS, Code.Option.Common.SELECT, setStatusOptions, setError);
  
    const onNewEntry = async () => {
      if(keyId===Code.Key.NEW) {
        const clientName = await API.Data.GetClientName(Number(clientId));
        setFormData((prevData) => ({
          ...prevData,
          status_id: Code.Option.Billing.TOSUBMIT,
          doctor_id: doctorId ? Number(doctorId) : 2,
          exam_id: examId ? Number(examId) : 2,
          client_id: Number(clientId),
          client_name: Utility.Value.Text(clientName), 
        }));
      }
      setLoading(false);
    };
    onNewEntry();
    
  }, []);

  const handleFieldChange = (
    row: number,
    field: keyof BillingColumn,
    newValue: string | null
  ) => {
    setBillingColumnData((prev) => {
      const rowNum = row;
      const existingIndex = prev.findIndex((item) => item.row === rowNum);

      let priceAmount = 0;

      if(field === Name.Billing.Hsc){
        const selected = hscOptions.find(option => option.value === Number(newValue));
        if(selected){
          const dob = formData?.client_dob;
          const isChild = dob && Utility.isValid.ChildAge(dob);
          priceAmount = isChild ? Number(selected.data3) : Number(selected.data2);
        }
        
      }
    
      if (field === Name.Billing.Hsc && (!newValue || newValue.trim() === "")) {
        return prev.filter((item) => item.row !== rowNum);
      } 
      else {
        if (existingIndex !== -1) {
          return prev.map((item, idx) =>
            idx === existingIndex 
              ? { 
                  ...item, 
                  [field]: newValue,
                  ...(field === Name.Billing.Hsc && { billing_price: priceAmount, billing_quantity: 1, billing_amount: priceAmount })
                } 
              : item
          );
        } else {
          return [
            ...prev, 
            { 
              row: rowNum, 
              [field]: newValue,
              ...(field === Name.Billing.Hsc && { billing_price: priceAmount, billing_quantity: 1, billing_amount: priceAmount })
            }
          ];
        }
      }
    });
  };

  useEffect(() => {
    const fetchClientDob = async () => {
      const clientId = formData.client_id;
      if (clientId) {
        API.Data.GetByKeyId<Client>(Code.Form.Name.CLIENT, clientId.toString(), setLoading, setError)
          .then(async(data) => { 
            if(data) {
              console.log("Client DOB:", data.client_dob);
              setFormData((prev: any) => ({
                ...prev,
                client_dob: data.client_dob,
              }));
            }
          });
      }
    };
  
    fetchClientDob();
  }, [formData.client_id]);

  const onSubmit = async (e: React.FormEvent) => {
  if (!Toast.Validate.Form(e, setMessage)) return;
  for (let index = 0; index < billingColumnData.length; index++) {
    const item = billingColumnData[index];
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...item,
      ...formData,
      ...addonData,
    });

    console.log(`Item ${index}:`, finalData);

    try {
      await API.Data.Save(formName, keyId, finalData, setMessageTemp, true, Code.Form.PopupClose.NONE );
    } catch (error) {
      console.error(`Error saving item ${index}:`, error);
      // Optionally break or continue based on your needs
    }
  }
  //Utility.Message.Info([`Multiple billing created.`], setMessage);
  Utility.Button.PopupClose();
};

  useEffect(() => {
    console.log("----->",billingColumnData);
  }, [billingColumnData]);

  useEffect(() => {
    console.log("----->",formData);
  }, [formData]);

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} Privilege={Privilege} />
          <Control.Tab.Header titles={["Multiple Billing"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Invoice.Date} value={formData.billing_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} require={true} currentDate={true} />
                <Field.Select id={Name.Doctor.Id} value={formData.doctor_id} title={Title.DoctorName} options={doctorOptions} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,40,1]} require={true} />
                <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,40,0]} disabled={true} />
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Row>
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Grid.Items values={[
                    ["HSC", width.hsc],
                    ["Diagnosis", width.diagnosis], 
                    ["Price", width.price, Code.Align.RIGHT ], 
                    ["Quantity", width.quantity, Code.Align.RIGHT], 
                    ["Amount", width.amount, Code.Align.RIGHT] 
                  ]} />
                </Control.Form.Title>
                <Control.Form.List>
                  {columnOptions.map((item, index) => {
                    const current = billingColumnData?.find((d) => d.row === item.value) || {};
                    return(
                    <Control.Form.Index key={item.value} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Option id={Name.Billing.Hsc} value={current.billing_hsc_id} optionValues={hscOptions} onChange={(e) => handleFieldChange(item.value, "billing_hsc_id", e.target.value)} size={[width.hsc]} />
                        <Control.Form.Option id={Name.Billing.Diagnosis1} value={current.billing_diagnosis1_id} optionValues={diagOptions} onChange={(e) => handleFieldChange(item.value, "billing_diagnosis1_id", e.target.value)} size={[width.diagnosis]} />
                        <Control.Form.Number id={Name.Billing.Price} value={current.billing_price} onChange={(e) => handleFieldChange(item.value, "billing_price", e.target.value)}  size={[width.price]} />
                        <Control.Form.Number id={Name.Billing.Quantity} value={current.billing_quantity} onChange={(e) => handleFieldChange(item.value, "billing_quantity", e.target.value)}  size={[width.quantity]} />
                        <Control.Form.Number id={Name.Billing.Amount} value={current.billing_amount} onChange={(e) => handleFieldChange(item.value, "billing_amount", e.target.value)}  size={[width.amount]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                    );
                  })}
                </Control.Form.List>
              </Control.Form.Table>
              <Control.Row>
                <Field.Area id={Name.Billing.Comment} value={formData.billing_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
            </Control.Tab.Content>

          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default BillingMultiForm;